import React, { useEffect, useState } from "react";
import "./ShiftAssigns.css";
import { shiftListAssign, shiftsAssignmentSubmit, shiftsGets, getDesignationsByRoleId } from "../../../services/shiftsService";
import { format } from "date-fns";
import { getAuditLog } from "../../../utils/calculateDaysInMonthUtils";
import { formatTime } from "../../../utils/validations";
import Select from "react-select";
const ShiftAssigns = () => {
  const [employeeList, setEmployeeList] = useState([]);
  const [shiftList, setShiftList] = useState([]);
  const [editingRows, setEditingRows] = useState(new Set()); // Track which rows are in edit mode
  const [editedData, setEditedData] = useState({}); // { id: { shiftId, shiftStartDate, shiftEndDate } }
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });

  const districtId = localStorage.getItem("districtId");
  const districtName = localStorage.getItem("districtName");
  const roleId = Number(localStorage.getItem("roleId"));
  const [designationOptions, setDesignationOptions] = useState([]);
  const [designation, setDesignation] = useState("");
  // Fetch data
  const fetchShiftAssigns = async () => {
    try {
      const response = await shiftListAssign(districtId, designation);
      setEmployeeList(response.data);
    } catch (error) {
      console.error("Error fetching shifts:", error);
    }
  };

  const loadShifts = async () => {
    try {
      const res = await shiftsGets();
      setShiftList(res.data);
    } catch (err) {
      console.log("Error loading shifts", err);
    }
  };
  useEffect(() => {
    if (roleId) {
      loadDesignations();
    }
  }, [roleId]);

  const loadDesignations = async () => {
    try {
      const data = await getDesignationsByRoleId(roleId);

      const list = data.map(d => ({
        value: d.id,
        label: d.designationName,
      }));

      setDesignationOptions(list);
    } catch (error) {
      console.error("Error loading designations:", error);
    }
  }
  useEffect(() => {
    if (districtId) {
      fetchShiftAssigns();
    } else {
      setEmployeeList([]);
    }
  }, [districtId, designation]);

  // Start editing a row
  const startEdit = (id) => {
    setEditingRows(prev => new Set(prev).add(id));

    // Initialize edited data if not exists
    if (!editedData[id]) {
      const emp = employeeList.find(e => e.id === id);
      setEditedData(prev => ({
        ...prev,
        [id]: {
          shiftId: emp.shiftId,
          shiftStartDate: emp.shiftStartDate,
          shiftEndDate: emp.shiftEndDate,
        }
      }));
    }
  };
  const handleInputChange = (selectedOption, field) => {
    const value = selectedOption ? selectedOption.value : "";
    switch (field) {

      case "designation":
        setDesignation(value);
        break;

      default:
        break;
    }
    // setErrors(prev => ({ ...prev, [field]: null }));
  };

  // Cancel editing a row
  const cancelEdit = (id) => {
    setEditingRows(prev => {
      const updated = new Set(prev);
      updated.delete(id);
      return updated;
    });
    setEditedData(prev => {
      const updated = { ...prev };
      delete updated[id];
      return updated;
    });
  };

  // Handle input change
  const handleChange = (id, field, value) => {
    setEditedData(prev => ({
      ...prev,
      [id]: {
        ...prev[id],
        [field]: value
      }
    }));
  };

  // Check if there are any pending changes
  const hasChanges = Object.keys(editedData).length > 0;

  // Submit all changes at once
  const handleBulkSubmit = async () => {
    if (!hasChanges) {
      setMessage({ text: "No changes to submit", type: "info" });
      return;
    }

    setIsSubmitting(true);
    setMessage({ text: "", type: "" });

    const list = Object.keys(editedData).map(id => {
      const data = editedData[id];
      const emp = employeeList.find(e => e.id === parseInt(id));
      return {
        postingId: emp.postingId,
        shiftId: parseInt(data.shiftId),
        shiftStartDate: data.shiftStartDate,
        shiftEndDate: data.shiftEndDate
      };
    });

    const payload = {
      auditLog: getAuditLog(),
      list,
    };

    try {
      const response = await shiftsAssignmentSubmit(payload);

      if (response.status === 200 || response.status === 201) {
        // Update UI with new values
        const updatedList = employeeList.map(emp => {
          if (editedData[emp.id]) {
            const updated = editedData[emp.id];
            const newShift = shiftList.find(s => s.shiftId === parseInt(updated.shiftId));
            return {
              ...emp,
              shiftId: parseInt(updated.shiftId),
              shiftStartDate: updated.shiftStartDate,
              shiftEndDate: updated.shiftEndDate,
              shiftName: newShift?.shiftName || emp.shiftName,
            };
          }
          return emp;
        });

        setEmployeeList(updatedList);
        setEditingRows(new Set());
        setEditedData({});
        setMessage({ text: "All changes submitted successfully!", type: "success" });
        setTimeout(() => setMessage({ text: "", type: "" }), 5000);
      }
    } catch (error) {
      console.error("Submit failed:", error);
      setMessage({ text: "Failed to submit changes. Please try again.", type: "error" });
    } finally {
      setIsSubmitting(false);
    }
  };
  // Auto close popup after 3 seconds
  useEffect(() => {
    if (message.text) {
      const timer = setTimeout(() => {
        setMessage({ text: "", type: "" });
      }, 3000); // 3 seconds

      return () => clearTimeout(timer);
    }
  }, [message.text]);
  const handleClear = () => {
    setDesignation("");
  }
  return (
    <div className="shift-assign-container">
      <h2 className="page-title">
        Shift Assignment List - <span className="district-highlight">{districtName}</span>
      </h2>
      <div className="d-flex justify-content-center align-items-center mt-2 mb-1">
        <div className="mb-0"><label>Designation : </label></div>
        <div style={{ minWidth: "200px" }}>
          <Select
            name="designation"
            options={designationOptions}
            value={designationOptions.find(opt => opt.value === designation) || null}
            onChange={option => handleInputChange(option, "designation")}
            placeholder="Select Designation"
            isClearable
            className="w-100"
          />
        </div>
      </div>
      <div className="text-end">
        <button className="btn btn-danger mb-3 clear-s-b-disg" onClick={() => { handleClear() }} disabled={!designation}>
          Clear
        </button>
      </div>


      <div className="table-wrapper">
        <table className="shift-table-assign">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Employee Name</th>
              <th>Designation</th>
              <th>Contact</th>
              <th>From Date</th>
              <th>To Date</th>
              <th>Shift</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {employeeList.length === 0 ? (
              <tr>
                <td colSpan="8" className="no-data">No Records Found</td>
              </tr>
            ) : (
              employeeList.map((emp, index) => {
                const isEditing = editingRows.has(emp.id);
                const currentData = editedData[emp.id] || emp;

                return (
                  <tr key={emp.id} className={isEditing ? "editing-row" : ""}>
                    <td>{index + 1}</td>
                    <td className="text-start">{emp.fullName}</td>
                    <td>{emp.designation}</td>
                    <td>{emp.contactNumber}</td>

                    {/* From Date */}
                    <td>
                      {isEditing ? (
                        <input
                          type="date"
                          className="form-input"
                          value={format(new Date(currentData.shiftStartDate), "yyyy-MM-dd")}
                          onChange={(e) => handleChange(emp.id, "shiftStartDate", e.target.value)}
                          min={new Date().toISOString().split("T")[0]}
                        />
                      ) : (
                        format(new Date(emp.shiftStartDate), "dd-MM-yyyy")
                      )}
                    </td>

                    {/* To Date */}
                    <td>
                      {isEditing ? (
                        <input
                          type="date"
                          className="form-input"
                          value={format(new Date(currentData.shiftEndDate), "yyyy-MM-dd")}
                          onChange={(e) => handleChange(emp.id, "shiftEndDate", e.target.value)}
                          min={currentData.shiftStartDate || format(new Date(emp.shiftStartDate), "yyyy-MM-dd")}
                        />
                      ) : (
                        format(new Date(emp.shiftEndDate), "dd-MM-yyyy")
                      )}
                    </td>

                    {/* Shift */}
                    <td>
                      {isEditing ? (
                        <select
                          className="form-select"
                          value={currentData.shiftId || ""}
                          onChange={(e) => handleChange(emp.id, "shiftId", e.target.value)}
                        >
                          <option value="">Select Shift</option>
                          {shiftList.map(shift => (
                            <option key={shift.shiftId} value={shift.shiftId}>
                              {shift.shiftName} ({shift.startTime} - {shift.endTime})
                            </option>
                          ))}
                        </select>
                      ) : (
                        <span className="shift-display">
                          {emp.shiftName && emp.shiftStartTime && emp.shiftEndTime
                            ? `${emp.shiftName}: ${formatTime(emp.shiftStartTime)} - ${formatTime(emp.shiftEndTime)}`
                            : "Not Assigned"}
                        </span>

                      )}
                    </td>

                    {/* Action Buttons */}
                    <td className="action-buttons">
                      {isEditing ? (
                        <button onClick={() => cancelEdit(emp.id)} className="btn-cancel">
                          Cancel
                        </button>
                      ) : (
                        <button onClick={() => startEdit(emp.id)} className="btn-edit">
                          Edit
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
      {message.text && (
        // <div className={`alert alert-${message.type}`}>
        //   {message.text}
        // </div>

        <div className="confirm-overlay">
          <div className="success-message-popup">{message.text}</div>
        </div>
      )}

      {/* Single Submit Button at Bottom */}
      {/* {hasChanges && ( */}
      <div className="bulk-submit-footer">
        <div className="change-summary">
          You have modified {Object.keys(editedData).length} employee(s)
        </div>
        <button
          onClick={handleBulkSubmit}
          disabled={editingRows.size === 0 || isSubmitting}
          className="btn-submit-all"
        >
          {isSubmitting ? "Submitting..." : `Submit All Changes (${Object.keys(editedData).length})`}
        </button>
      </div>
      {/* )} */}
    </div>
  );
};

export default ShiftAssigns;